import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { PersonsService, SalesDocument } from '@icc/b2b/shared';
import { ConfigService } from '@icc/shared/config.service';
import { logger } from '@icc/shared/helpers';
import { DialogRef, DIALOG_DATA } from '@icc/ui';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'icc-confirm-order-dialog',
    templateUrl: './confirm-order-dialog.component.html',
    styleUrls: ['./confirm-order-dialog.component.scss'],
})
export class ConfirmOrderDialogComponent {
    confirmLater = true;
    departments: Record<number, string> = {};

    canBeOrdered = false;

    deliveryDates: string[] = [];
    deliveryDate: string | null = null;

    message = '';
    messages: string[] = [];
    messageState: 'default' | 'error' = 'default';

    constructor(
        @Inject(DIALOG_DATA)
        public data: {
            document: SalesDocument;
            buyDocuments: SalesDocument[];
        },
        private translateService: TranslateService,
        private dialogRef: DialogRef,
        private personsService: PersonsService,
        private http: HttpClient,
        private configService: ConfigService,
    ) {
        this.loadDepartments();

        this.init();
    }

    async init() {
        if (this.configService.user.orderIntegration === 'OrdersSynchronization') {
            await this.requestExternalId();
        } else {
            this.canBeOrdered = true;
        }
    }

    async requestExternalId() {
        const document = this.data.buyDocuments.length > 0 ? this.data.buyDocuments[0] : this.data.document;
        this.message = this.translateService.instant(
            'SALES_DOCUMENT|Składanie zamówienia w systemie zewnętrznym.',
        );
        this.messages = [];
        this.messageState = 'default';
        try {
            const result = await this.http.post<{
                externalId: string;
                deliveryDates: string[];
            }>('/api/b2b/order-external/external-id', {
                customerId: document.client?.companyVatNr,
                documentId: document.uuid,
                description: document.description,
            }).toPromise();
            if (result.externalId) {
                this.message = '';
                this.messages = [];
                this.canBeOrdered = true;
                if (result.deliveryDates?.length) {
                    this.message = '';
                    this.messages = [];
                    this.deliveryDates = result.deliveryDates;
                }
            }
        } catch (e) {
            logger.error(e);
            if (e.error?.messages?.length) {
                this.message = '';
                this.messages = e.error.messages;
            } else {
                this.message = this.translateService.instant(
                    'SALES_DOCUMENT|Zlecenie w systemie zewnętrznym nie zostało złożone.');
                this.messages = [];
            }
            this.messageState = 'error';
        }
    }

    close() {
        this.dialogRef.close();
    }

    confirmOrder() {
        this.dialogRef.close({
            confirmLater: this.confirmLater,
            deliveryDate: this.deliveryDate,
        });
    }

    async loadDepartments() {
        await this.personsService.loaded;
        this.departments = this.personsService.getDepartments();
    }
}
